import { Injectable } from '@angular/core';
import {GA4BaseEvent} from '../../models/google-analytics.model';

declare global {
  interface Window {
    dataLayer: GA4BaseEvent[];
  }
}

@Injectable({
  providedIn: 'root',
})
export class WindowService {
  static get window(): Window {
    return window;
  }
}
